import { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { POLICIES, POLICY_UPDATED } from "@/lib/policies";

function PolicyBody({ policy }) {
  return (
    <article data-testid={`policy-${policy.slug}`} className="max-w-3xl">
      <h1 className="font-serif text-4xl md:text-5xl text-[#1E3A2B] mb-3">{policy.title}</h1>
      <p className="text-xs text-[#5C6B63] mb-6">Last updated {POLICY_UPDATED} · Alex Hospitality Services</p>
      <p className="text-[#3B4A42] leading-relaxed mb-10">{policy.intro}</p>
      {policy.sections.map((s) => (
        <section key={s.h} className="mb-9">
          <h2 className="font-serif text-lg text-[#1C2421] mb-3">{s.h}</h2>
          {(s.p || []).map((t) => <p key={t} className="text-sm md:text-base text-[#3B4A42] leading-relaxed mb-3">{t}</p>)}
          {s.list && (
            <ul className="space-y-2">
              {s.list.map((t) => (
                <li key={t} className="text-sm md:text-base text-[#3B4A42] leading-relaxed pl-5 relative before:content-[''] before:absolute before:left-0 before:top-[0.6em] before:w-2 before:h-px before:bg-[#C86D51]">{t}</li>
              ))}
            </ul>
          )}
        </section>
      ))}
      <p className="text-sm text-[#5C6B63] border-t border-[#E2DACF] pt-6">Questions? Write to info@jawaitrails.com or WhatsApp +91 93753 32211.</p>
    </article>
  );
}

export default function Policies() {
  const { section } = useParams();
  const policy = POLICIES.find((p) => p.slug === section);
  useEffect(() => { window.scrollTo(0, 0); }, [section]);
  if (!section) return <Navigate to="/policies/cancellation" replace/>;
  if (!policy) return <Navigate to="/policies/cancellation" replace/>;

  return (
    <div className="jt-container py-16 grid gap-10 md:grid-cols-[220px_1fr]" data-testid="policies-page">
      <aside className="md:sticky md:top-28 self-start">
        <div className="jt-eyebrow mb-4">Policies</div>
        <nav className="flex md:flex-col gap-1 overflow-x-auto">
          {POLICIES.map((p) => (
            <Link key={p.slug} to={`/policies/${p.slug}`} data-testid={`policy-nav-${p.slug}`}
              className={`whitespace-nowrap text-sm px-3 py-2 rounded-lg border-l-2 transition-colors ${p.slug === section ? "border-[#C86D51] bg-white text-[#1E3A2B] font-medium" : "border-transparent text-[#5C6B63] hover:text-[#1E3A2B]"}`}>
              {p.title}
            </Link>
          ))}
        </nav>
      </aside>
      <PolicyBody policy={policy}/>
    </div>
  );
}
